import { render } from "./componentSignature.vue?vue&type=template&id=f4dab81e"
import script from "./componentSignature.vue?vue&type=script&lang=js"
export * from "./componentSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__